import { ErrorMessage } from '@hookform/error-message';
import React, { ComponentProps } from 'react';
import styled from 'styled-components';

const ErrorMessageWrapper = styled.span`
  color: red;
  margin-top: 4px;
`;

type Props = {
  className?: string;
} & ComponentProps<typeof ErrorMessage>;

const FormErrorMessage = ({ className, ...errorMessageProps }: Props) => {
  return (
    <ErrorMessage
      render={({ message }) => (
        <ErrorMessageWrapper className={className}>{message}</ErrorMessageWrapper>
      )}
      {...errorMessageProps}
    />
  );
};

export default styled(FormErrorMessage)``;
